import React from 'react'
import { tokenDelete } from '../../api/login'
import style from './index.module.css'
import { Button } from 'antd'
interface Props {
    history?: any;
    visible: boolean;
    onClose: () => void;
}

const LogOut = (props: Props) => {

    /**
     * @name 退出登录
     */
    const onLogOut = async (): Promise<any> => {
        let response: any = await tokenDelete()
        if (response.state.code === 0) {
            props.onClose()
            localStorage.clear()
            // localStorage.removeItem('pl_token')
            // localStorage.removeItem('pl_userInfo')

            window.location.hash = '#/login'
            window.location.reload()
        }
    }

    const render = (
        <div>
            <div className={style.bg}></div>
            <div className={style.exit_modal}>
                <p>退出登录</p>
                <p>确定要退出吗？</p>
                <div>
                    <div>
                        <Button className='mr-10' onClick={() => props.onClose()}>取消</Button>
                        <Button danger type="primary" onClick={() => onLogOut()}>退出</Button>
                    </div>
                </div>
            </div>
        </div>
    )
    return props.visible ? render : null
}

export default LogOut
